import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { RoleValidationSchema } from '@/features/tcardRoles/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateRoleProps {
  roleId: string
  permissions: { permission_id: string }[]
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateRole = ({ roleId, permissions, onSuccess, onError }: UseUpdateRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateRole'],
    mutationFn: async (form: RoleValidationSchema) => {
      const payload = {
        display_name: form.display_name,
        description: form.description,
        perma_name: null,
        permission_roles_attributes: permissions,
        level: form.level !== undefined ? Number(form.level) || 0 : undefined,
        can_bypass_linked_client_company_restriction: form.can_bypass_linked_client_company_restriction || false,
        can_bypass_linked_establishment_company_restriction: form.can_bypass_linked_establishment_company_restriction || false,
      }

      return privateAxios.put(`/roles/${roleId}`, { ...payload })
    },
    onSuccess,
    onError,
  })
}

export default useUpdateRole
